import TeamIcon from './TeamIcon.jsx';

export default TeamIcon;
